import {
  FireShader,
  SlimeballShader,
  WaterWaveShader,
  SnowfallShader,
  FireballShader,
  SpinningCubeShader,
  FirePreview,
  SlimeballPreview,
  WaterWavePreview,
  SnowfallPreview,
  FireballPreview,
  SpinningCubePreview,
} from '@shadeables/shadermodel';

export const shaderModels = {
  fire: {
    name: 'Fire',
    Model: FireShader,
    Preview: FirePreview,
    type: '2d' as const,
  },
  slimeball: {
    name: 'Slimeball',
    Model: SlimeballShader,
    Preview: SlimeballPreview,
    type: '2d' as const,
  },
  waterwave: {
    name: 'Water Wave',
    Model: WaterWaveShader,
    Preview: WaterWavePreview,
    type: '2d' as const,
  },
  snowfall: {
    name: 'Snowfall',
    Model: SnowfallShader,
    Preview: SnowfallPreview,
    type: '2d' as const,
  },
  fireball: {
    name: 'Fireball',
    Model: FireballShader,
    Preview: FireballPreview,
    type: '2d' as const,
  },
  spinningcube: {
    name: 'Spinning Cube',
    Model: SpinningCubeShader,
    Preview: SpinningCubePreview,
    type: '3d' as const,
  },
};

export type ShaderName = keyof typeof shaderModels;

export type ShaderModel = InstanceType<
  (typeof shaderModels)[ShaderName]['Model']
>;
